<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-storage-group-detail class="flex" [storageGroup]="storageGroup" (close)="close()">
  </app-storage-group-detail>
</div>
